import React from 'react';
import { Box, Button, Chip, IconButton, Typography, Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';

/**
 * CommandBar — pasek kontekstowy kampanii (sekcja 8.11).
 * Status + główna akcja + podgląd + menu.
 */
function CommandBar({ statusLabel, statusColor = 'success', primaryAction, onPrimaryAction, secondaryActions = [], onBack }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        py: 1.5,
        px: { xs: 2, md: 0 },
        mb: 3,
        bgcolor: 'background.default',
        borderBottom: `1px solid ${theme.palette.divider}`,
        flexWrap: 'wrap',
      }}
    >
      {onBack && (
        <Typography
          variant="body2"
          sx={{ cursor: 'pointer', color: 'primary.main', fontWeight: 600, mr: 1 }}
          onClick={onBack}
        >
          ← Kampanie
        </Typography>
      )}
      <Chip label={statusLabel} color={statusColor} size="small" sx={{ fontWeight: 700, textTransform: 'uppercase' }} />
      <Box sx={{ flexGrow: 1 }} />
      {primaryAction && (
        <Button variant="contained" size="small" onClick={onPrimaryAction} sx={{ borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px` }}>
          {primaryAction}
        </Button>
      )}
      {secondaryActions.length > 0 && (
        <>
          <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
            <MoreVertIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            {secondaryActions.map((action) => (
              <MenuItem
                key={action.label}
                onClick={() => { action.onClick?.(); setAnchorEl(null); }}
              >
                {action.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
}

export default CommandBar;
